import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrGuestDocumentRetention.ts
var t = () => e("guestDocumentRetention");
//#endregion
export { t as useTrGuestDocumentRetention };
